import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {Dialog, Button, DialogActions, DialogContent, DialogContentText} from '@material-ui/core'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {authStore} from '@utils'
import * as css from './GDPRComplianceCheck.css'

const GDPR_COOKIE_NAME = 'GDPR'
/// region Store

export class GDPRComplianceCheckStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }


  @action onReject = () => {
    authStore.logout(true)
  }

  @action onAccept = () => {
    document.cookie = `${GDPR_COOKIE_NAME}=1`
    this.justAccepted = true
  }

  @observable justAccepted = false
  get hasAccepted() {
    return document.cookie.match(/^(.*;)?\s*GDPR\s*=\s*[^;]+(.*)?$/)
  }
}

export const GDPRComplianceCheckStoreContext = React.createContext<GDPRComplianceCheckStore>(null)
export const useGDPRComplianceCheckStore = () => React.useContext(GDPRComplianceCheckStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const GDPRComplianceCheck = observer<MyProps>(function GDPRComplianceCheck({className, ...props}) {
  const obsProps = useAsObservableSource({props}),
    store = useVipLocalStore((stores) => new GDPRComplianceCheckStore(stores, obsProps)),
    {onReject, onAccept, justAccepted, hasAccepted} = store

  if (hasAccepted || justAccepted) return null

  return (
    <GDPRComplianceCheckStoreContext.Provider value={store}>
      <Dialog className={classNames(css.root, className)} open>
        <DialogContent>
          <span className={css.text}>This site uses cookies for identification purposes.</span>
        </DialogContent>
        <DialogActions>
          <Button color='primary' onClick={onReject}>Cancel</Button>
          <Button color='secondary' onClick={onAccept}>Accept</Button>
        </DialogActions>
      </Dialog>
    </GDPRComplianceCheckStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/shared/components/ui/components/GDPRComplianceCheck.tsx